<div
  class="delete-account-modal"
  role="dialog"
  [attr.aria-modal]="true"
  [attr.aria-labelledby]="'delete-account-heading'"
  [attr.aria-describedby]="'delete-account-description delete-account-authorization'">
  <button
    type="button"
    class="close-button-wrapper"
    (click)="close()"
    [attr.aria-label]="'COMMON.ACTION.CLOSE' | translate">
    <mat-icon aria-hidden="true">close</mat-icon>
  </button>

  <h2 class="header">{{ 'DELETE_ACCOUNT_MODAL.DELETING_ACCOUNT' | translate }}</h2>

  <p id="delete-account-description" class="text">
    {{ 'DELETE_ACCOUNT_MODAL.DELETING_ACCOUNT_DESCRIPTION' | translate }}
  </p>

  <p id="delete-account-authorization" class="authorization-text">
    {{ 'DELETE_ACCOUNT_MODAL.DELETING_ACCOUNT_AUTHORIZATION' | translate }}
  </p>

  <form [formGroup]="form">
    <nz-form-item>
      <nz-form-label nzFor="password" nzRequired>
        {{ 'COMMON.LABEL.PASSWORD' | translate }}
      </nz-form-label>

      <nz-form-control [nzSm]="12" [nzXs]="24">
        <nz-input-group [nzSuffix]="suffixTemplate">
          <input
            nz-input
            placeholder="Password"
            id="password"
            [type]="isPasswordVisible ? 'text' : 'password'"
            formControlName="password"
            required
            autocomplete="current-password"
            [attr.aria-invalid]="form.controls.password.invalid && form.controls.password.touched"
            [attr.aria-describedby]="
              form.controls.password.invalid && form.controls.password.touched ? 'password-error' : null
            " />

          <ng-template #suffixTemplate>
            <button
              type="button"
              class="password-toggle"
              (click)="isPasswordVisible = !isPasswordVisible"
              [attr.aria-pressed]="isPasswordVisible"
              [attr.aria-label]="
                isPasswordVisible
                  ? ('COMMON.ACTION.HIDE_PASSWORD' | translate)
                  : ('COMMON.ACTION.SHOW_PASSWORD' | translate)
              ">
              <mat-icon>
                {{ isPasswordVisible ? 'eye-invisible' : 'eye' }}
              </mat-icon>
            </button>
          </ng-template>
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>
  </form>

  <!-- ERROR -->
  @if (form.controls.password.invalid && form.controls.password.touched) {
    <mat-error id="password-error">
      {{ form.controls.password.errors | errorsFormatingAndTranslate }}
    </mat-error>
  }

  <div class="submit">
    <button
      class="submit-button"
      type="button"
      (click)="confirm()"
      [disabled]="!form.valid"
      mat-raised-button
      color="warn">
      {{ 'COMMON.ACTION.REMOVE' | translate }}
    </button>
  </div>
  <div class="close">
    <button class="close-button" type="button" (click)="close()" mat-raised-button color="primary">
      {{ 'COMMON.ACTION.CANCEL' | translate }}
    </button>
  </div>
</div>
